import { render, staticRenderFns } from "./Overall_user.vue?vue&type=template&id=7cb2c6a8&scoped=true&"
import script from "./Overall_user.vue?vue&type=script&lang=js&"
export * from "./Overall_user.vue?vue&type=script&lang=js&"
import style0 from "./Overall.css?vue&type=style&index=0&id=7cb2c6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb2c6a8",
  null
  
)

export default component.exports